module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/soc_2-ee3f418ecb58fa15f94d478fe432f095.svg";